import { BillingGroupModal } from "../BillingGroupModal";
import type { ReassignBillingGroupModalProps } from "./types";

export const ReassignBillingGroupModal = (props: ReassignBillingGroupModalProps) => (
  <BillingGroupModal {...props} mode="reassign" />
);
